// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"736":"3fc5d99a","787":"dc7b5a83","850":"3a73e8a6"}[chunkId] + ".chunk.js";
};